import { ProductState, ProductTypes, ProductActionTypes } from './types'
import { Reducer } from 'redux'

const initialState: ProductState = {
  productList: { items: [] }
}

type ReducerOpts = Reducer<ProductState, ProductActionTypes>
const reducer: ReducerOpts = (state = initialState, action: ProductActionTypes): ProductState => {
  let index = -1
  switch (action.type) {
    case ProductTypes.PRODUCT_CREATE:
      return {
        ...state,
        productList: { ...state.productList, items: [action.payload, ...state.productList.items] }
      }
    case ProductTypes.PRODUCT_UPDATE:
      index = state.productList.items.findIndex(item => item.id === action.payload.id)
      return {
        ...state,
        productList: {
          ...state.productList,
          items: [
            ...state.productList.items.slice(0, index),
            action.payload,
            ...state.productList.items.slice(index + 1)
          ]
        }
      }
    case ProductTypes.PRODUCT_DELETE:
      index = state.productList.items.findIndex(item => item.id === action.payload)
      return {
        ...state,
        productList: {
          ...state.productList,
          items: [
            ...state.productList.items.slice(0, index),
            ...state.productList.items.slice(index + 1)
          ]
        }
      }
    case ProductTypes.PRODUCT_GET:
      return { ...state, product: action.payload }
    case ProductTypes.PRODUCT_LIST:
      return { ...state, productList: { items: action.payload, pagination: action.pagination } }
    default:
      return state
  }
}

export default reducer
